import React from 'react';
import { Box, Typography } from '@mui/material';

import { TEAM_ICON_DEFAULT } from '../../../../../common/staticData';

const GameOverviewHeader = ({ isOur, ourname, enemyname, ourImage, enemyImage, onChangeTeam, mb }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                marginBottom: mb
            }}
        >
            {/* Our Team */}
            <Box
                onClick={() => onChangeTeam(true)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: isOur ? '#6366f1' : '#ffffff',
                    border: isOur ? '1px solid #6366f1' : '1px solid #e5e7eb',
                    transition: 'all 0.2s ease',
                    boxShadow: isOur ? '0 2px 8px rgba(99, 102, 241, 0.3)' : '0 1px 2px rgba(0,0,0,0.05)',
                    '&:hover': {
                        borderColor: '#6366f1',
                        backgroundColor: isOur ? '#6366f1' : '#f5f3ff'
                    }
                }}
            >
                <Box
                    sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '6px',
                        backgroundColor: isOur ? 'rgba(255,255,255,0.2)' : '#f9fafb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={ourImage
                            ? (ourImage.includes(process.env.REACT_APP_S3_URI)
                                ? ourImage
                                : process.env.REACT_APP_S3_URI + ourImage)
                            : TEAM_ICON_DEFAULT}
                        alt="Our Team"
                        style={{ maxWidth: '22px', maxHeight: '22px', objectFit: 'contain' }}
                    />
                </Box>
                <Typography
                    sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: isOur ? '#ffffff' : '#374151'
                    }}
                >
                    {ourname}
                </Typography>
            </Box>

            {/* VS Divider */}
            <Typography
                sx={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#9ca3af'
                }}
            >
                vs
            </Typography>

            {/* Opponent Team */}
            <Box
                onClick={() => onChangeTeam(false)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    backgroundColor: !isOur ? '#6366f1' : '#ffffff',
                    border: !isOur ? '1px solid #6366f1' : '1px solid #e5e7eb',
                    transition: 'all 0.2s ease',
                    boxShadow: !isOur ? '0 2px 8px rgba(99, 102, 241, 0.3)' : '0 1px 2px rgba(0,0,0,0.05)',
                    '&:hover': {
                        borderColor: '#6366f1',
                        backgroundColor: !isOur ? '#6366f1' : '#f5f3ff'
                    }
                }}
            >
                <Box
                    sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '6px',
                        backgroundColor: !isOur ? 'rgba(255,255,255,0.2)' : '#f9fafb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                    <img
                        src={enemyImage
                            ? (enemyImage.includes(process.env.REACT_APP_S3_URI)
                                ? enemyImage
                                : process.env.REACT_APP_S3_URI + enemyImage)
                            : TEAM_ICON_DEFAULT}
                        alt="Opponent Team"
                        style={{ maxWidth: '22px', maxHeight: '22px', objectFit: 'contain' }}
                    />
                </Box>
                <Typography
                    sx={{
                        fontSize: '13px',
                        fontWeight: 600,
                        color: !isOur ? '#ffffff' : '#374151'
                    }}
                >
                    {enemyname}
                </Typography>
            </Box>
        </Box>
    );
};

export default GameOverviewHeader;
